module.exports = __webpack_public_path__ + "static/img/v70TwoDetailImg.60fe5d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70TwoDetailImg.png
// module id = w+Pw
// module chunks = 1